import login from "./login";
import finderUser from "./finder_user";
import createNewContract from "./create_new_contract";
import addUserToContract from "./add_user_to_contract";

const useCases = {
    login,
    finderUser,
    createNewContract,
    addUserToContract
};

export default useCases;
